import { Component, h } from '@stencil/core';

@Component({
  tag: 'ci-drawer',
  styleUrl: 'ci-drawer.scss',
})
export class ciDrawer {
  menuToggle() {
    document.getElementById('menuButton').classList.toggle('active');
    const ciMobileSubnav = document.getElementsByClassName('ciMobileSubnav')[0] as HTMLElement;
    const ciBodyTag = document.getElementsByTagName('body')[0] as HTMLElement;
    const overlay = document.getElementById('overlay');
    const menu = document.getElementById('menu');
    menu.className = 'ci-drawer-menu closeMenu';
    overlay.className = 'ci-drawer-overlay closeOverlay';
    setTimeout(function () {
      ciMobileSubnav.style.visibility = 'hidden';
      ciBodyTag.style.overflow = 'visible';
    }, 200);
  }

  render() {
    return (
      <div class="ci-drawer">
        <div class="ci-drawer-window">
          <div class="ci-drawer-overlayClickable" onClick={() => this.menuToggle()}></div>
          <div class="ci-drawer-overlay" id="overlay"></div>
          <div class="ci-drawer-menu" id="menu">
            <slot />
          </div>
        </div>
      </div>
    );
  }
}
